/**
 * Steht die Monatsreflexion aus? (F-14, F-40) - dieselbe Regel wie in der
 * Glocke: ab dem Monatsletzten und an den zwei Tagen danach.
 */
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import { monatName } from '@/domain/review/periods';
import { faelligerMonat } from '@/domain/review/faellig';
import { today } from '@/lib/datetime';

/** `'September 2026'`, wenn die Reflexion aussteht - sonst `null`. */
export function useMonthReviewDue(): { key: string; name: string } | null {
  const monat = faelligerMonat(today());
  const vorhanden = useLiveQuery(async () => (monat ? (await db.monthlyReviews.get(monat)) !== undefined : true), [monat], true);
  if (!monat || vorhanden) return null;
  return { key: monat, name: monatName(monat) };
}
